import React from 'react';
import ReactDOM from 'react-dom';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';

import store, { history } from './store';
import './index.less';
import Routes from './routes';
import ScrollToTop from './components/ScrollToTop';
import InstallPrompt from './components/InstallPrompt';
import AnalyticsTracker from './components/AnalyticsTracker';
import AnalyticsHelper from './helpers/analytics';
import reportWebVitals from './reportWebVitals';
import { register as registerServiceWorker } from './serviceWorkerRegistration';

const darkPrimary = '#091622';
const colorPrimary = '#002855'; // HKUST brand navy (Pantone 295 C)
const colorLink = '#0088FF';
const colorWhite = '#FFFFFF';
const colorStrokeField = '#D9D9D9';

const theme = {
	token: {
		colorPrimary,
		colorLink,
		fontFamily: "'Muli', sans-serif",

		// Custom Colors
		colorDarkPrimary: darkPrimary,
		colorWhite,
		colorStrokeField
	},
	components: {
		Layout: {
			siderBg: darkPrimary
		},
		Menu: {
			darkItemSelectedBg: colorLink,
			itemHeight: 58
		},
		Button: {
			primaryShadow: null
		},
		Input: {
			activeShadow: null
		}
	}
};


AnalyticsHelper.init();

ReactDOM.render(
	<React.StrictMode>
		<Provider store={store()}>
			<ConnectedRouter history={history}>
				<ConfigProvider theme={theme}>
					<ScrollToTop />
					<AnalyticsTracker />
					<Routes />
					<InstallPrompt />
				</ConfigProvider>
			</ConnectedRouter>
		</Provider>
	</React.StrictMode>,
	document.getElementById('root')
);

reportWebVitals();
registerServiceWorker();
